import { render } from "./ForgotPassword.vue?vue&type=template&id=928bf4d2"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=928bf4d2&lang=css"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__